import { URLRegex, getRuleErrorMessage } from "@/utils/formHelper";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrEventValidation = (data, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "infoTitle",
      rules: {
        minLength: {
          value: 1,
          message: getRuleErrorMessage("infoTitle", "minLength", data),
        },
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("infoTitle", "maxLength", data),
        },
      },
    },
    {
      name: "infoDescription",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("infoDescription", "maxLength", data),
        },
      },
    },
    {
      name: "infoActionTitle",
      rules: {
        maxLength: {
          value: 50,
          message: getRuleErrorMessage("infoActionTitle", "maxLength", data),
        },
      },
    },
    {
      name: "infoActionUrl",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("infoActionUrl", "pattern", data),
        },
      },
    },
    {
      name: "locationAddress",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("locationAddress", "maxLength", data),
        },
      },
    },
    {
      name: "locationNumeration",
      rules: {
        maxLength: {
          value: 40,
          message: getRuleErrorMessage("locationNumeration", "maxLength", data),
        },
      },
    },
    {
      name: "locationPostalCode",
      rules: {
        maxLength: {
          value: 40,
          message: getRuleErrorMessage("locationPostalCode", "maxLength", data),
        },
      },
    },
    {
      name: "locationCity",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("locationCity", "maxLength", data),
        },
      },
    },
    {
      name: "locationState",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("locationState", "maxLength", data),
        },
      },
    },
    {
      name: "locationCountry",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("locationCountry", "maxLength", data),
        },
      },
    },
    {
      name: "organizerName",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("organizerName", "maxLength", data),
        },
      },
    },
    {
      name: "organizerPhone",
      rules: {
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("organizerPhone", "maxLength", data),
        },
      },
    },
    {
      name: "organizerEmail",
      rules: {
        pattern: {
          value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g,
          message: getRuleErrorMessage("organizerEmail", "pattern", data),
        },
      },
    },
    {
      name: "organizerWebsite",
      rules: {
        pattern: {
          value: new RegExp(URLRegex),
          message: getRuleErrorMessage("organizerWebsite", "pattern", data),
        },
      },
    },
    {
      name: "organizerAbout",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("organizerAbout", "maxLength", data),
        },
      },
    },
  ];
};
